import { l } from '@locale/setupI18n';

export const isYearGreyedOutInFocusMode = (year: string, selectedFocusYear: string | undefined) =>
  year === l('_Historic')
    ? false
    : Boolean(selectedFocusYear) && new Date(year) > new Date(selectedFocusYear!);
